import React from 'react';
import {
  obterPercentualDownload,
  obterTextoProgressoDownload,
} from '~/modules/Modulos/helpers/arquivos.helper';
import {
  AnexoProgresso,
  AnexoStatus,
  BarraProgresso,
  BarraIndeterminada,
} from './arquivos.form.styled';

function AnexoDownloadProgresso({ progresso, corTema }) {
  if (!progresso) {
    return null;
  }

  const texto = obterTextoProgressoDownload(progresso);
  const percentual = obterPercentualDownload(progresso);

  return (
    <AnexoProgresso>
      <AnexoStatus aria-live="polite">{texto}</AnexoStatus>
      {percentual === null ? (
        <BarraIndeterminada
          role="progressbar"
          aria-label={texto}
          aria-valuetext={texto}
        />
      ) : (
        <BarraProgresso
          percent={percentual}
          size="small"
          status="active"
          showInfo={false}
          strokeColor={corTema}
          aria-label={texto}
        />
      )}
    </AnexoProgresso>
  );
}

export default AnexoDownloadProgresso;
